import { render } from "./List.vue?vue&type=template&id=7aae226d&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=7aae226d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aae226d"]])

export default __exports__